import React from 'react';
import { api, PortalContext } from '@portal/arq-portal-core';

export function Comentario(props: any): JSX.Element {
    
    const likeComment = () => {

        let jsonLike = {
            ContentId: elemento.WallCommentId,
        };
        api.post('/be/piupointcreatelikewallcomment/', {"Entrada": {"json": JSON.stringify(jsonLike),"cia": cia}}).then(()=>{
            canLike?setNlikes(nLikes + 1): setNlikes(nLikes - 1);
            setCanLike(!canLike);
        });
    };

    const { elemento } = props;
    const [canLike, setCanLike] = React.useState(elemento?.CanLike);
    const [nLikes, setNlikes] = React.useState(elemento?.Likes? elemento.Likes.length:0);
    const { ciaGestiona } = React.useContext(PortalContext);

    var urlParams = new URLSearchParams(window.location.search);
    var ciaUrl = urlParams.get('cia');
    let cia = (ciaUrl === 'SCO' || ciaUrl === 'SBI' || ciaUrl === 'SPU') ? ciaUrl : ciaGestiona;

    React.useEffect(()=>{
        setCanLike(elemento?.CanLike);
        setNlikes(elemento?.Likes? elemento.Likes.length:0)
    },[elemento]);

    const getTimeDiff = (CreationDate: string) => {

        let today = new Date();
        let created = new Date(CreationDate + 'Z');
        let hours = 0;
        let minutes = 0;
        let days = 0;
        let month = 0;
        let years = 0;

        const timeDiff = today.getTime() - created.getTime();
        minutes = Math.floor(timeDiff / (1000 * 60));
        hours = Math.floor(timeDiff / (1000 * 60 * 60));
        days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
        month = (today.getMonth() + 1) - (created.getMonth() + 1) + (12 * (today.getFullYear() - created.getFullYear()));
        years = today.getFullYear() - created.getFullYear();

        if (minutes < 60) {
            return ` ${minutes === 1 ? 'un' : `${minutes}`} minuto${minutes === 1 ? '' : 's'}`;
        } else if (hours < 24) {
            return ` ${hours === 1 ? 'una' : `${hours}`} hora${hours === 1 ? '' : 's'}`;
        } else if (days < 30) {
            return ` ${days === 1 ? 'un' : `${days}`} día${days === 1 ? '' : 's'}`;
        } else if (month < 12) {
            return ` ${month === 1 ? 'un' : `${month}`} mes${month === 1 ? '' : 'es'}`;
        } else {
            return ` ${years === 1 ? 'un' : `${years}`} año${years === 1 ? '' : 's'}`;
        }
    }
    
    return (
        <div className="detalleComentario"> 
            <div className="detalleComment">
                <div className="elemHeader">
                    <div className="comTime">hace 
                        {getTimeDiff(elemento?.CreationDate)}
                    </div>
                    <div className="comActions" onClick={likeComment}>
                        <i className={`icon-pro-like ${!canLike ? `is-liked` : ``}`}></i>
                        <span className="inline">({nLikes})</span>
                    </div>
                </div>
                <div className="comment">{elemento?.ShortBody}</div>
                <div className="user">Publicado por <span>{elemento?.User.UserName} ({elemento?.User.JobTitle})</span></div>

            </div>
        </div>
    )
}